import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onAnimationStart' | 'onDragStart' | 'onDragEnd' | 'onDrag'> {
  children: React.ReactNode;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'secondary';
}
export function Button({
  children,
  fullWidth = false,
  size = 'lg',
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const sizeClasses = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const variantClasses = {
    primary: 'bg-pink-600 hover:bg-pink-500 text-white shadow-[0_8px_20px_rgb(236,72,153,0.35)] hover:shadow-[0_12px_25px_rgb(236,72,153,0.45)]',
    secondary: 'bg-rose-500 hover:bg-rose-400 text-white shadow-[0_8px_20px_rgb(244,63,94,0.3)] hover:shadow-[0_12px_25px_rgb(244,63,94,0.4)]'
  };
  return <motion.button whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative overflow-hidden rounded-full font-bold tracking-wide
        transition-all duration-300 ease-out
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props as any} data-id="element-253">
      <span className="relative z-10" data-id="element-254">{children}</span>
    </motion.button>;
}
export const CHECKOUT_URL = 'https://checkout.aula-mater.online/cart/66759304020013:1';
interface CTAProps {
  className?: string;
  href?: string;
  scrollTo?: string;
  label?: string;
  variant?: 'primary' | 'secondary';
}
export function CTA({
  className = '',
  href,
  scrollTo,
  label = 'QUIERO ACCEDER AHORA',
  variant = 'primary'
}: CTAProps) {
  const handleClick = () => {
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      return;
    }
    if (href) window.location.href = href;
  };
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-255">
      <Button size="xl" variant={variant} className="w-full sm:w-auto min-w-[280px]" onClick={handleClick} data-id="element-256">
        {label}
      </Button>
      <div className="flex items-center gap-2 text-xs font-medium text-slate-500" data-id="element-257">
        <span data-id="element-258">Garantía 7 días</span>
        <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-259" />
        <span data-id="element-260">Acceso inmediato</span>
        <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-261" />
        <span data-id="element-262">Mercado Pago</span>
      </div>
    </div>;
}